import { app } from './lib/app'
import BookingWidgetSymphony from './BookingWidgetSymphony'

app('booking-widget-symphony' , BookingWidgetSymphony)

